import { Spin } from 'antd';
import { get } from 'lodash';
import React from 'react';

import { TableCellDescriptions } from '../../../components/TableCellDescriptions';
import { apiClient } from '../../../graphql/api/apiClient';
import { usegetFunnelAppointmentByUserRoleQuery } from '../../../graphql/api/generated';
import { UserRoleDetailsFragment } from '../../../graphql/hasura/generated';
import { formatPhoneNumber, formatTimestamp, formatUserName } from '../../../utils';
import { FunnelAppointmentStatus } from '../../Property/components/FunnelAppointmentStatus';

interface IFunnelAppointmentDescriptionsProps {
  userRole: UserRoleDetailsFragment;
  tz?: string;
}

export const FunnelAppointmentDescriptions: React.FC<IFunnelAppointmentDescriptionsProps> = (props) => {
  const { userRole, tz } = props;
  const { userRoleId, sourcePayload } = userRole;
  const funnelAppointmentId = get(sourcePayload, 'funnelAppointmentId');

  const { data, loading } = usegetFunnelAppointmentByUserRoleQuery({
    client: apiClient,
    skip: !funnelAppointmentId,
    variables: { userRoleId },
    fetchPolicy: 'cache-and-network',
  });

  if (loading) {
    return <Spin />;
  }

  const funnelAppointment = data?.funnelAppointmentByUserRole;

  if (!funnelAppointment) {
    return null;
  }

  const { client } = funnelAppointment;

  return (
    <TableCellDescriptions
      descriptions={{
        'Appointment ID': funnelAppointmentId,
        'Appointment Status': <FunnelAppointmentStatus status={funnelAppointment.status} />,
        'Start Time': formatTimestamp(funnelAppointment.startTime, tz),
        'Prospect Name': formatUserName(client),
        'Phone Number': formatPhoneNumber(client?.phoneNumber),
        Email: client?.email,
      }}
    />
  );
};
